import * as React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import * as Redux from 'react-redux'

import * as model from '@owl-nest/models'
import * as env from '@owl-nest/config'
import * as plume from '@ulule/owl-kit-components/next'

import { useNavigation } from './public/hooks/useNavigation'
import { DetailLayout } from './public/layout/DetailLayout'
import * as projectModel from './public/models/project'
import { PATHS } from './public/paths'
import { ComingSoon } from './public/views/coming-soon'
import { RootState } from './reducers'

export function MainRouter(): React.ReactElement<unknown> {
  const { project, token } = Redux.useSelector<RootState, { project: projectModel.Project; token?: string }>(
    (state) => ({
      project: state.application.project.data,
      token: state.application.project.token,
    }),
  )

  const navigation = useNavigation()

  const isComingSoonEnabled = model.project.isComingSoonEnabled(project)
  const isForbidden = projectModel.redirectToForbidden(project) && token === undefined
  const redirectToComingSoon = projectModel.redirectToComingSoon(project) && token === undefined

  return (
    <React.Suspense fallback={<plume.Spinner />}>
      <Routes>
        {isComingSoonEnabled && <Route path={navigation.pathTo(PATHS.COMING_SOON).pathname} element={<ComingSoon />} />}
        {redirectToComingSoon && (
          <Route path="*" element={<Navigate to={navigation.pathTo(PATHS.COMING_SOON).pathname} />} />
        )}
        {isForbidden && <Route path="*" element={<Forbidden />} />}
        <Route path="*" element={<DetailLayout />} />
      </Routes>
    </React.Suspense>
  )
}

function Forbidden(): React.ReactElement<unknown> {
  window.location.href = env.FORBIDDEN_URL
  return <></>
}
